import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  SpinLoading, TableFilterSection,
  SectionTitle,
  PageContainer,
  TableButton
} from '../../styles/BasicStyles';
import { Col, Icon, Modal, Popconfirm, Row } from 'antd';
import { CreateWeddingCanva, GetWeddingCanvas, SoftDeleteWeddingCanva, UpdateWeddingCanva } from '../../infra/requests/WeddingCanvaRequests';
import Table from '../../components/table/Table';
import WeddingCanvaModal from './WeddingCanvaModal';
import Alerts from '../../components/alert/Alert';
import { GetAllWeddingCanvaTemplates } from '../../infra/requests/WeddingCanvaTemplateRequests';
import { GetWeddingCanvaConfigs } from '../../infra/requests/WeddingCanvaConfigsRequests';
import { renderWeddingCanvaStatus } from './WeddingCanvaUtils';
import BaseButton from '../buttons/BaseButton';
import { withLocalize } from 'react-localize-redux';

const { confirm } = Modal;
const REACT_APP_API = process.env.REACT_APP_API;

class WeddingCanvaPage extends Component {
  state = {
    loading: true,
    canvaEditorVisible: false,
    canvasObjects: [],

    columns: [
      {
        title: this.props.translate("TITLE"),
        render: data => data?.name || ''
      },
      {
        title: this.props.translate("TEMPLATE"),
        render: data => data?.template?.name?.pt || ''
      },
      {
        title: this.props.translate("STATUS"),
        render: data => renderWeddingCanvaStatus(data?.status, this.props.translate(data?.status)) || ''
      },
      {
        title: this.props.translate("ACTIONS"),
        width: '250px',
        render: data => {
          return <Fragment>
            {data?.status === "IN_PROGRESS" && <React.Fragment>
              <TableButton onClick={e => this.openCanvaEditModal(data)}>
                <Icon type="edit" />
                {this.props.translate("EDIT")}
              </TableButton>
              <TableButton onClick={e => this.openCanvaEditor(data)}>
                <Icon type="eye" />
                {this.props.translate("CANVA")}
              </TableButton>
              <TableButton onClick={e => e.stopPropagation()}>
                <Popconfirm
                  placement="topRight"
                  title={this.props.translate("REMOVE_CANVA_QUESTION")}
                  okText={this.props.translate("DELETE")}
                  onConfirm={async () => { await this.deleteWeddingCanva(data?._id) }}>
                  <Icon type="delete" />
                  {this.props.translate("DELETE")}
                </Popconfirm>
              </TableButton>
            </React.Fragment>}
            {(data?.status === "DELETED" || data?.status === "SUBMITTED" || data?.status === "APPROVED") && <React.Fragment>
              <TableButton onClick={e => this.openCanvaEditor(data)}>
                <Icon type="eye" />
                {this.props.translate("CANVA")}
              </TableButton>
            </React.Fragment>}
          </Fragment>
        }
      }
    ],
    rows: [],
    total: 0,
    pageSize: 15,
    currentPage: 1,
    search: '',

    showCanvaEditModal: false,
    canvaTemplates: [],
    selectedWeddingCanva: null,

    showCanvaPreviewModal: false,
    previewImageUrl: null,
    selectedWeddingCanvaForPreview: null
  };

  componentDidMount() {
    this.getWeddingCanvaConfigs();
    this.loadCanvaTemplates();
    this.updateDataTable();
  }

  componentWillUnmount() {

  }

  getWeddingCanvaConfigs = async () => {
    const res = await GetWeddingCanvaConfigs();
    if (res?.success) {
      const configs = res?.data ? res?.data : null;
      if (configs && configs?.blockCanvaForCouple) {
        this.props.history.push('/404');
      }
    }
  }

  loadCanvaTemplates = async () => {
    const filters = {
      deleted: { $ne: true },
      active: true,
      availableCouple: true
    };
    const res = await GetAllWeddingCanvaTemplates(filters);
    if (res?.success) {
      const data = res?.data;
      const canvaTemplates = data?.map(t => {
        return { key: t?._id, value: t?.name?.pt };
      });
      this.setState({ canvaTemplates });
    }
  }

  updateDataTable = async () => {
    const { wedding } = this.props;
    const { filters, currentPage, pageSize } = this.state;

    let reqFilters = filters ? filters : {};
    reqFilters.deleted = { $ne: true };
    reqFilters.wedding = wedding?.wedding?._id;

    this.setState({ loading: true });
    try {
      const result = await GetWeddingCanvas(currentPage, pageSize, reqFilters);
      this.setState({
        rows: result?.data && result.data.items ? result.data.items : [],
        total: result?.data && result.data.total ? result.data.total : 0,
        pageSize: result?.data && result.data.limit ? result.data.limit : 30,
        loading: false
      });
    } catch (e) {
      this.setState({ loading: false });
      console.error(e);
    }
  }

  // openCanvaEditor = (selectedWeddingCanva) => {
  //   this.setState({ canvaEditorVisible: true, selectedWeddingCanva });
  // };

  openCanvaEditor = (selectedWeddingCanva) => {
    const { wedding } = this.props;

    if (selectedWeddingCanva?.status === 'SUBMITTED' || selectedWeddingCanva?.status === 'APPROVED') {
      const imageUrl =
        selectedWeddingCanva?.canvaImage?.url ||
        (selectedWeddingCanva?.canvaImage?.file?._id
          ? `${REACT_APP_API}/files/${selectedWeddingCanva?.canvaImage?.file?._id}`
          : null);

      this.setState({
        showCanvaPreviewModal: true,
        previewImageUrl: imageUrl,
        selectedWeddingCanvaForPreview: selectedWeddingCanva
      });
      return;
    }

    this.props.history.push(
      `/wedding/${wedding?.wedding?._id}/canva/editor`,
      { canvaId: selectedWeddingCanva?._id }
    );
  };

  handleChangePage = currentPage => {
    this.setState({ currentPage }, this.updateDataTable);
  };

  handleChangeRowsPerPage = (currentSize, pageSize) => {
    this.setState({ pageSize, currentPage: 1 }, this.updateDataTable);
  };

  handleFilterChange = filters => {
    this.setState({ filters, currentPage: 1 }, this.updateDataTable);
  };

  openCanvaEditModal = (selectedWeddingCanva = null) => {
    const { canvaTemplates } = this.state;

    if (selectedWeddingCanva) {
      const selectedCanvaTemplate = { key: selectedWeddingCanva?.template?._id, value: selectedWeddingCanva?.template?.name?.pt || '' };
      const selectedAlreadyAdded = canvaTemplates.find(t => selectedCanvaTemplate ? t?.key === selectedCanvaTemplate?.key : false);
      if (!selectedAlreadyAdded) {
        this.setState(prev => ({
          canvaTemplates: [...prev.canvaTemplates, selectedCanvaTemplate]
        }));
      }
    }

    const selectedObj = JSON.parse(JSON.stringify(selectedWeddingCanva));
    if (selectedObj && typeof selectedObj.template === 'object') {
      selectedObj.template = selectedObj?.template?._id;
    }

    this.setState({
      showCanvaEditModal: true,
      selectedWeddingCanva: selectedObj
        ? selectedObj
        : {}
    });
  }

  closeCanvaEditModal = async () => {
    await this.loadCanvaTemplates();

    this.setState({
      showCanvaEditModal: false,
      selectedWeddingCanva: null
    });
  };

  submitWeddingCanva = async (values) => {
    const { wedding, translate } = this.props;

    try {
      values.wedding = wedding?.wedding?._id;

      const result = values?._id
        ? await UpdateWeddingCanva(values?._id, values, 'CANVA_INFO')
        : await CreateWeddingCanva(values);

      if (result.success) {
        Alerts.new({
          type: "success",
          title: translate("SUCCESS"),
          text: values?._id ? translate("CANVA_UPDATED") : translate("CANVA_ADDED")
        });
        await this.closeCanvaEditModal();
        this.updateDataTable();
      } else {
        return Alerts.new({
          type: "error",
          title: translate("ERROR"),
          text: result.data
        });
      }
    } catch (error) {
      return Alerts.new({
        type: "error",
        title: translate("ERROR"),
        text: error
      });
    }
  }

  deleteWeddingCanva = async id => {
    const { translate } = this.props;

    const result = await SoftDeleteWeddingCanva(id);

    if (result.success) {
      Alerts.new({
        type: "success",
        title: translate("SUCCESS"),
        text: translate("CANVA_DELETED")
      });
      await this.updateDataTable();
    } else {
      return Alerts.new({
        type: 'error',
        title: translate("ERROR"),
        text: result.data
      });
    }
  }

  render() {
    const { translate } = this.props;
    const { loading, columns, rows, total, currentPage, pageSize, selectedWeddingCanvaForPreview } = this.state;

    if (loading) return <SpinLoading />;

    return (
      <PageContainer style={{ marginTop: '10px' }}>
        <TableFilterSection>
          <Row gutter={[12, 12]}>
            <Col lg={12} md={12} sm={12} xs={24}>
              <SectionTitle style={{ marginBottom: 0 }}>
                Canvas do casamento
              </SectionTitle>
            </Col>

            <Col
              lg={12}
              md={12}
              sm={12}
              xs={24}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <BaseButton
                type="primary"
                icon="plus"
                text="Novo canva"
                onClick={() => this.openCanvaEditModal()}
              />
            </Col>
          </Row>
        </TableFilterSection>

        <div className="table-responsive">
          <Table
            columns={columns}
            rows={rows}
            loading={loading}
            total={total}
            currentPage={currentPage}
            pageSize={pageSize}
            rowKey="_id"
            hasPagination
            showHeader
            emptyIcon="setting"
            emptyText={translate("EMPTY_CANVAS_TABLE")}
            handleChangePage={this.handleChangePage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>

        {this.state.showCanvaEditModal && (
          <WeddingCanvaModal
            templates={this.state.canvaTemplates}
            isOpen={this.state.showCanvaEditModal}
            initialValues={this.state.selectedWeddingCanva}
            onClose={this.closeCanvaEditModal}
            onSubmit={this.submitWeddingCanva}
          />
        )}

        <Modal
          title={selectedWeddingCanvaForPreview?.name}
          visible={this.state.showCanvaPreviewModal}
          footer={null}
          onCancel={() =>
            this.setState({
              showCanvaPreviewModal: false,
              previewImageUrl: null
            })
          }
          width={1200}
          centered
        >
          {this.state.previewImageUrl ? (
            <img
              src={this.state.previewImageUrl}
              alt="Canva"
              style={{
                width: '100%',
                maxHeight: '80vh',
                objectFit: 'contain'
              }}
            />
          ) : (
            <p>{translate("NO_IMAGE_AVAILABLE")}</p>
          )}
        </Modal>
      </PageContainer>
    );
  }
}

const mapStateToProps = state => ({
  wedding: state.wedding
});

const mapActionToProps = dispatch =>
  bindActionCreators({ dispatch }, dispatch);

export default withLocalize(connect(mapStateToProps, mapActionToProps)(WeddingCanvaPage));
